import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M15.4163 3.33337H16.1663V2.58337H15.4163V3.33337ZM15.4163 17.0834V17.8334H16.1663V17.0834H15.4163ZM15.4163 2.58337H6.58301V4.08337H15.4163V2.58337ZM3.83301 5.33337V15.0834H5.33301V5.33337H3.83301ZM6.58301 17.8334H15.4163V16.3334H6.58301V17.8334ZM16.1663 17.0834V3.33337H14.6663V17.0834H16.1663ZM3.83301 15.0834C3.83301 16.6022 5.06422 17.8334 6.58301 17.8334V16.3334C5.89265 16.3334 5.33301 15.7737 5.33301 15.0834H3.83301ZM6.58301 2.58337C5.06422 2.58337 3.83301 3.81459 3.83301 5.33337H5.33301C5.33301 4.64302 5.89265 4.08337 6.58301 4.08337V2.58337Z"
      fill={fill}
    />
    <path
      d="M15.4163 14.1666H16.1663V13.4166H15.4163V14.1666ZM15.4163 17.0833V17.8333H16.1663V17.0833H15.4163ZM15.4163 13.4166H6.04134V14.9166H15.4163V13.4166ZM6.04134 17.8333H15.4163V16.3333H6.04134V17.8333ZM16.1663 17.0833V14.1666H14.6663V17.0833H16.1663ZM3.83301 15.625C3.83301 16.8446 4.82171 17.8333 6.04134 17.8333V16.3333C5.65014 16.3333 5.33301 16.0162 5.33301 15.625H3.83301ZM6.04134 13.4166C4.82171 13.4166 3.83301 14.4053 3.83301 15.625H5.33301C5.33301 15.2338 5.65014 14.9166 6.04134 14.9166V13.4166Z"
      fill={fill}
    />
    <path
      d="M7.08301 5.5C6.66879 5.5 6.33301 5.83579 6.33301 6.25C6.33301 6.66421 6.66879 7 7.08301 7V5.5ZM13.333 7C13.7472 7 14.083 6.66421 14.083 6.25C14.083 5.83579 13.7472 5.5 13.333 5.5V7ZM7.08301 7H13.333V5.5H7.08301V7Z"
      fill={fill}
    />
  </g>
);

export default Icon;
